import React from 'react';
import { Page } from '@fiverr-private/perseus';
import Index from '../components/Index';

class UserPage extends Page {
    render() {
        return (<Index {...this.props}/>);
    }
}

export default UserPage;
